import type { ErrorResponse } from '../types';
import { PtwError } from './PtwError';
import { t } from 'i18next';

export function isApiError(error: Error): error is ApiError {
  return error.constructor === ApiError;
}

export class ApiError extends PtwError {
  response: Response;
  errorResponse?: ErrorResponse;

  constructor(response: Response, errorResponse?: ErrorResponse) {
    super();
    this.response = response;
    this.errorResponse = errorResponse;
  }

  static async create(response: Response) {
    const errorResponse = await this.extractError(response);
    const newError = new ApiError(response, errorResponse);

    newError.message =
      (errorResponse.i18n && t(errorResponse.i18n.key, errorResponse.i18n.parameters)) ||
      errorResponse.message ||
      t('Error.Category.Other.message');

    return newError;
  }
}
